export const state = () => ({
	custom_cover_letter: null,
});

export const mutations = {
	setCustomCoverLetter(state: any, payload: any) {
		state.custom_cover_letter = payload;
	},
};

export const getters = {
	getCustomCoverLetter: (state: any) => state.custom_cover_letter,
};

export const actions = {
	async fetchCustomCoverLetter(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/custom-cover-letters')
				.then((res) => {
					state.commit('setCustomCoverLetter', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeCustomCoverLetter(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/custom-cover-letters', {
					cover_letter: payload,
				})
				.then((res) => {
					state.commit('setCustomCoverLetter', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async updateGeneralPreferences(state: any, payload: any) {
		// Remove the null entries from the payload and determine
		// the payload for updating the user's profile progress.
		Object.keys(payload).forEach(key => payload[key] === null && delete payload[key]);

		const requiredGeneralPreferencesFields = [
			'contact_method',
		];

		let requiredJobPreferencesFields = [
			'job_type',
			'location',
			'relocate',
			'salary_from',
			'salary_to',
		];

		// Ensure the notice_period and notice_period_type are set if the earliest_start_date is not set.
		payload.earliest_start_date
			? requiredJobPreferencesFields.push('earliest_start_date')
			: requiredJobPreferencesFields.push('notice_period', 'notice_period_type');

		// Check if the user has completed the general preference and job preference requirements.
		const progressPayload = {
			update_general_preferences: requiredGeneralPreferencesFields.every((key) => key in payload),
			update_job_preferences: requiredJobPreferencesFields.every((key) => key in payload),
		};

		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/general-preferences', payload)
				.then((res) => {
					state.dispatch(
						'profile/progress/updateProfileProgress',
						progressPayload,
						{ root: true },
					);

					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateCustomCoverLetter(state: any, payload: any) {
		state.commit('setCustomCoverLetter', payload);
	},
};
